import React, { useState } from "react";
import Modal from "@material-ui/core/Modal";
import { useTranslation } from "react-i18next";
import { Color } from "config/colors";
import { ButtonStyled } from "components/buttons/buttons.styled";
import { Text } from "components/Typography/text.styled";
import { AbsenceModalBody } from "./timeReportModal.styled";
import { TimeReportResolution, TimeReportStatus } from "model/TimeReport";
import { DropdownWithLabel } from "../general/dropDownWithLabel/dropdownWithLabel.component";
import { FontSize } from "config/font";
import { TextareaWithLabel } from "../general/textAreaWithLabel/textareaWithLabel.component";

type Props = {
  reportAbsenceModalOpen: boolean;
  setReportAbsenceModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleTimeReport: (
    status:
      | TimeReportStatus.SUBMITTED
      | TimeReportStatus.REJECTED
      | TimeReportStatus.CLOSED,
    absence: TimeReportResolution,
    absenceNote?: string | undefined
  ) => void;
};

export const ReportAbsenceModal: React.FC<Props> = ({
  reportAbsenceModalOpen,
  setReportAbsenceModalOpen,
  handleTimeReport,
}) => {
  const { t } = useTranslation();
  const initialFormData = {
    absenceNote: "",
    absence: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  const leaveTypes = [
    {
      label: t("CompanyTimeReport.SickLeave"),
      value: TimeReportResolution.SICKLEAVE,
    },
    {
      label: t("CompanyTimeReport.SickLeaveChild"),
      value: TimeReportResolution.SICKLEAVECHILD,
    },
    {
      label: t("CompanyTimeReport.Vacation"),
      value: TimeReportResolution.VACATION,
    },
    {
      label: t("CompanyTimeReport.ParentalLeave"),
      value: TimeReportResolution.PARENTALLEAVE,
    },
    {
      label: t("CompanyTimeReport.LeaveOfAbsence"),
      value: TimeReportResolution.LEAVEOFABSENCE,
    },
    { label: t("CompanyTimeReport.Other"), value: TimeReportResolution.OTHER },
    {
      label: t("CompanyTimeReport.CancelledByEmployer"),
      value: TimeReportResolution.CANCELLEDBYEMPLOYER,
    },
  ];

  return (
    <>
      <Modal
        open={reportAbsenceModalOpen}
        onClose={() => {
          setReportAbsenceModalOpen(false);
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <AbsenceModalBody>
          <Text fontSize={FontSize.H4} style={{ marginLeft: 5 }}>
            {t("CompanyTimeReport.ReportAbsence")}
          </Text>
          <DropdownWithLabel
            label={t("CompanyTimeReport.Absence")}
            options={leaveTypes}
            value={formData.absence}
            onChange={(value) =>
              setFormData({
                ...formData,
                absence: value,
              })
            }
            placeholder={t("CompanyTimeReport.ChooseAbsence")}
            required
          />
          <TextareaWithLabel
            label={t("CompanyTimeReport.Notes")}
            value={formData.absenceNote}
            onChange={(e) => {
              setFormData({
                ...formData,
                absenceNote: e.target.value,
              });
            }}
            placeholder={t("CompanyTimeReport.WriteNotes")}
            maxLength={500}
            minRows={4}
            width={400}
          />
          <ButtonStyled
            disabled={!formData.absence}
            backgroundColor={Color.LighterDestructive}
            isCancel
            onClick={() => {
              handleTimeReport(
                TimeReportStatus.CLOSED,
                formData.absence as TimeReportResolution,
                formData.absenceNote
              );
            }}
            style={{ marginTop: 20 }}
          >
            {t("CompanyTimeReport.ReportAbsence")}
          </ButtonStyled>
        </AbsenceModalBody>
      </Modal>
    </>
  );
};
